import Vue from 'vue';
import VueRouter from 'vue-router';
import iView from 'view-design';

import util from '@/libs/util'

import Setting from '@/setting';

import store from '@/store/index';
import secretUtils from '@/utils/secretUtils';
// 路由数据
import routes from './routes';
import dataUtils from '@/utils/dataUtils';

Vue.use(VueRouter);

// 导出路由 在 main.js 里使用
const router = new VueRouter({
    routes,
    mode: Setting.routerMode,
    base: Setting.routerBase
});

/**
 * 路由拦截
 * 权限验证
 */

router.beforeEach((to, from, next) => {
    if (Setting.showProgressBar) iView.LoadingBar.start();
    // 判断是否需要登录才可以进入

    // 这里依据 token 判断是否登录，可视情况修改
    if (to.matched.some(_ => _.meta.auth)) {
        let token = dataUtils.getData(Setting.key.token)
        if (token && token !== 'undefined') {
            if (to.path === '/economy/pay') {
                if (Object.keys(to.query).length != 0) {
                    // let decryptPayData = secretUtils.DecryptPayData(to.query.fd, 'dosionPay');
                    // console.log(decryptPayData, 'decryptPayData')
                    if (token == to.query.fd) {
                        next({ path: '/economy/pay' });
                    } else {
                        next({
                            name: 'login'
                        });
                    }
                }
            }else if (to.path === '/economy/supplier'){
                if (Object.keys(to.query).length != 0) {
                    // let decryptPayData = secretUtils.DecryptPayData(to.query.fd, 'dosionPay');
                    // console.log(decryptPayData, 'decryptPayData')
                    if (token == to.query.fd) {
                        next({ path: '/economy/supplier' });
                    } else {
                        next({
                            name: 'login'
                        });
                    }
                }
            }
            next();
        } else {
            // 没有登录的时候跳转到登录界面
            // 携带上登陆成功之后需要跳转的页面完整路径
            next({
                name: 'login',
                query: {
                    redirect: to.fullPath
                }
            });
        }
    } else {
        // 不需要身份校验 直接通过
        next();
    }
});

router.afterEach(to => {
    if (Setting.showProgressBar) iView.LoadingBar.finish();
    // 多页控制 打开新的页面
    store.dispatch('admin/page/open', to);
    // 更改标题
    util.title({
        title: to.meta.title
    });
    // 返回页面顶端
    window.scrollTo(0, 0);
});

export default router;
